export default function initQueryCarousels() {
	const carousels = document.querySelectorAll('[data-query-carousel]');

	if (!carousels.length) {
		return;
	}

	carousels.forEach((carousel) => {
		const track = carousel.querySelector('[data-carousel-track]');
		const prev = carousel.querySelector('[data-carousel-prev]');
		const next = carousel.querySelector('[data-carousel-next]');

		if (!track || !prev || !next) {
			return;
		}

		const getScrollAmount = () => {
			const firstItem = track.querySelector('article');

			if (!firstItem) {
				return track.clientWidth;
			}

			const gap = parseFloat(window.getComputedStyle(track).columnGap) || 24;

			return firstItem.getBoundingClientRect().width + gap;
		};

		prev.addEventListener('click', () => {
			track.scrollBy({
				left: -getScrollAmount(),
				behavior: 'smooth',
			});
		});

		next.addEventListener('click', () => {
			track.scrollBy({
				left: getScrollAmount(),
				behavior: 'smooth',
			});
		});
	});
}